import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';

import ToolbarFilterSelect from 'src/common/components/list-filters/ToolbarFilterSelect';
import { LanguageKeys } from 'src/common/constants/languages';
import useSystemOptionsStore from 'src/stores/systemOptionsStore';
import { hasActiveListFilter } from 'src/helpers/listFilters';

interface Props {
  roleFilter: string | null;
  onRoleFilter: (roleId: string | null) => void;
}

const UsersFilterPopoverContent = ({ roleFilter, onRoleFilter }: Props) => {
  const {
    t,
    i18n: { resolvedLanguage },
  } = useTranslation();
  const currentLang = resolvedLanguage as LanguageKeys;
  const { roles } = useSystemOptionsStore(s => s);

  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid size={12}>
        <ToolbarFilterSelect
          id="users-role-filter-label"
          label={t('users.role')}
          value={roleFilter ?? ''}
          onChange={v => onRoleFilter(v || null)}
          renderSelected={selected => {
            const role = roles.find(r => r.id === selected);
            return role ? role.i18n[currentLang] : selected;
          }}
        >
          <MenuItem value="">{t('base.all')}</MenuItem>
          {roles.map(role => (
            <MenuItem key={role.id} value={role.id}>
              {role.i18n[currentLang]}
            </MenuItem>
          ))}
        </ToolbarFilterSelect>
      </Grid>
    </Grid>
  );
};

export const usersFilterIsActive = (roleFilter: string | null) => hasActiveListFilter(roleFilter);

export default UsersFilterPopoverContent;
